import { useEffect, useState } from 'react';
import Input from '../../components/general/input/Input';
import './style.css';
import ButtonMinimalist from '../../components/general/button/ButtonMinimalist';
import Footer from '../../components/general/footer/Footer';
import TopBar from '../../components/general/topbar/TopBar';
import Select from '../../components/general/select/Select';
import ProductosBanner from '../../assets/images/banners/webps/interior2.webp'
import { Helmet } from 'react-helmet';
import ListaAires from '../../assets/texts/ListaAires.json'

export default function CalculadoraFR() {

  const [largo, setLargo] = useState(0);
  const [ancho, setAncho] = useState(0);
  const [alto, setAlto] = useState(0);
  const [personas, setPersonas] = useState(0);
  const [tipo, setTipo] = useState("Dormitorio");
  const [resultado, setResultado] = useState(0);

  const opciones = ["Dormitorio", "Cocina", "Comedor", "Living", "Cocina-Comedor", "Living-Comedor", "Salón"]
  const opcionesW = [(350*0.86), (2500*0.86), (250*0.86), (250*0.86), (2700*0.86), (300*0.86), (1500*0.86)]

  useEffect(() => {
    if(largo > 0){

    }else{
      window.scroll(0,0);
    }
  })

  const recom = ListaAires.map((item) => {
    if(item.frigorias - resultado > 500 || item.frigorias - resultado < -500){
      return null;
    }else{
      return <a href={item.link} target='_blank' rel='noreferrer'>{item.nombre}</a>
    }
  })

  const recomHtml = (
    <>
      <h2>Recomendaciones:</h2>
      {recom}
      <a href={'https://wa.me/5493434178703?text=¡Hola!+Quisiera+consultar+precio+de+un+aire+acondicionado+de+'+resultado+"+frigorias.+Hice+el+calculo+en+su+pagina,+y+ese+fue+el+resultado+que+me+dio"} target='_blank' rel='noreferrer'><ButtonMinimalist text="Pedir cotización" onClick={() => calcularFrigorias()}/></a>
    </>
  )

  const optionList = opciones.map((item) => {
    return <option value={item}>{item}</option>
  })

  function calcularFrigorias (){
    const espacio = largo * ancho * alto * 50;
    const humanos = personas * 150
    
    switch(tipo){
      case opciones[0]: setResultado(espacio+humanos+opcionesW[0]); break;
      case opciones[1]: setResultado(espacio+humanos+opcionesW[1]); break;
      case opciones[2]: setResultado(espacio+humanos+opcionesW[2]); break;
      case opciones[3]: setResultado(espacio+humanos+opcionesW[3]); break;
      case opciones[4]: setResultado(espacio+humanos+opcionesW[4]); break;
      case opciones[5]: setResultado(espacio+humanos+opcionesW[5]); break;
      case opciones[6]: setResultado(espacio+(humanos*1.33)+opcionesW[6]); break;
    }
  }

  const metaTags = {
    title: "Calculadora de Aire Acondicionado",
    description: "¿No estás seguro de la potencia que necesita tu aire acondicionado para casa? Con nuestra calculadora podes salir de dudas y tener una idea de que potencia vas a necesitar para refrigerar tu casa",
    url: "https://www.nicolinirefrigeracion.com.ar/calculadora-aire-acondicionado"
  }

  return (
    <div className='Calculator'>
      <TopBar />

      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" content={metaTags.description} />
        
        <meta property="og:site_name" content={metaTags.title} />
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={ProductosBanner} />
        <meta property="og:url" content={metaTags.url} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={ProductosBanner} />
      </Helmet>

      <div className='pageDisplay'>
        <div id='div1'>
          <h2>Cálculo de Aire Acondicionado</h2>
          <Input title="Largo de habitacion (m)" type="number" setInput={setLargo} onFocusOutColor="white" />
          <Input title="Ancho de habitacion (m)" type="number" setInput={setAncho} onFocusOutColor="white" />
          <Input title="Alto de habitacion (m)" type="number" setInput={setAlto} onFocusOutColor="white" />
          <Input title="Maximo de personas en la habitacion" type="number" setInput={setPersonas} onFocusOutColor="white" />
          <Select title="Tipo de Habitacion" setInput={setTipo} onFocusOutColor="white" optionList={optionList}/>
          <ButtonMinimalist text="Calcular Frigorias" onClick={() => calcularFrigorias()}/>
        </div>
        <div id='div2'>
          <div>
            <h2>Potencia necesaria:</h2>
            <h3>{resultado} Kcal/h</h3>
            <h4>{resultado} Fr (frigorias)</h4>
            <h4>{resultado*0.86} W (watts)</h4>
          </div>
          
          <div id='recomendations'>
            {resultado > 0 && recomHtml}
          </div>
        </div>
      </div>
      <Footer />  
    </div>
  )
}
